define('presentation/settings/liveReceptionistScripts/viewModels/liveReceptionistScriptCallControlsTabViewModel',[
        'businessServices/authentication/sessionAccountInfo',
        'constants/liveReceptionistQueueHoldSettingConstants',
        'constants/liveReceptionistScriptTypeConstants',
        'common/promises/promiseFactory',
        'presentation/settings/liveReceptionistScripts/validators/liveReceptionistScriptCallControlsTabViewModelValidator',
    ],
    function () {
        return function () {
            const self = this;

            const PromiseFactoryConstructor = require('common/promises/promiseFactory');
            const _promiseFactory = new PromiseFactoryConstructor();


            const _i18n = require('i18next');
            const LiveReceptionistQueueHoldSettingConstants = require('constants/liveReceptionistQueueHoldSettingConstants');
            const LiveReceptionistScriptTypeConstants = require('constants/liveReceptionistScriptTypeConstants');
            const _sessionAccountInfo = require('businessServices/authentication/sessionAccountInfo');

            let _facade = null;
            let _validator = null;

            self.isCompositionComplete = ko.observable(false);
            self.queueId = ko.observable('');
            self.availableQueueHoldSettings = [
                {
                    id: LiveReceptionistQueueHoldSettingConstants.HoldMusic,
                    text: _i18n.t('addLiveReceptionistScript:playHoldMusic')
                },
                {
                    id: LiveReceptionistQueueHoldSettingConstants.Ringing,
                    text: _i18n.t('addLiveReceptionistScript:playRinging')
                },
            ];
            self.selectedQueueHoldSetting = ko.observable(0);
            self.selectedType = ko.observable(LiveReceptionistScriptTypeConstants.LiveReceptionist.toString());

            self.isImpersonating = ko.pureComputed(() => {
                return _sessionAccountInfo.isImpersonating();
            });

            self.queueIdI18nKey = ko.pureComputed(() => {
                return self.selectedType() === LiveReceptionistScriptTypeConstants.LiveReceptionist.toString() ?
                    _i18n.t('addLiveReceptionistScript:queueIdCalls') :
                    _i18n.t('addLiveReceptionistScript:queueIdChats');
            });

            self.showQueueHoldSettings = ko.pureComputed(() => {
                return self.selectedType() === LiveReceptionistScriptTypeConstants.LiveReceptionist.toString();
            });

            self.validate = () => _validator.validate();

            self.detached = () => {
                self.isCompositionComplete(false);
            };

            self.compositionComplete = () => {
                self.isCompositionComplete(true);
            };

            self.activate = (queueId, selectedQueueHoldSetting, selectedType) => {
                self.queueId = queueId;
                self.selectedQueueHoldSetting = selectedQueueHoldSetting;
                self.selectedType = selectedType;

                const ValidatorConstructor = require('presentation/settings/liveReceptionistScripts/validators/liveReceptionistScriptCallControlsTabViewModelValidator');
                _validator = new ValidatorConstructor();

                return _initialize();
            };

            const _initialize = () => {
                return _promiseFactory.defer((initPromise) => {
                    _validator.registerViewModel(self, _facade);
                    initPromise.resolve();
                });
            };
        };
    });

